// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1-b8S","content":"ManualTimeModal_content__2pmFZ"};